import { c as _c } from "react/compiler-runtime";
import { ArrowRightIcon, HatWithCheck, HatWithPlus } from '@systemeio/ui/icons';
import { FieldErrorAndDescription } from '@systemeio/ui';
import { AccessTypeEnum } from 'modules/courses/courses/curriculum/enums/access-type-enum';
import { useCourse } from 'modules/courses/courses/hooks/use-course';
import { LightCourseEditor } from 'modules/courses/courses/light-course/components/light-course-editor';
import { CourseEditorTypeEnum, CourseId } from 'modules/courses/courses/types/course-interface';
import { DigitalResourcesTypeEnum } from 'modules/digital-product/enums/digital-resources-type-enum';
import { DigitalProductChangeInterface } from 'modules/digital-product/types/digital-product-interface';
import { ProductECourseItemEditType, ProductECourseItemErrorsType } from 'modules/stores/store/content/product/types/product-interface';
import { useStore } from 'modules/stores/store/hooks/use-store';
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query';
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
import { ClassicCourse } from './classic-course';
import { CourseTypeEnum } from './enum/course-type';
import { useCoursePreview } from './hooks/use-course-preview';
import { useCourseCurriculum } from 'modules/courses/courses/curriculum/hooks/use-cource-curriculum';
type Props = {
  courseId?: CourseId;
  tempState: ProductECourseItemEditType;
  tempProduct: DigitalProductChangeInterface;
  errors: ProductECourseItemErrorsType;
  setTempState: Dispatch<SetStateAction<ProductECourseItemEditType>>;
  setTempProduct: Dispatch<SetStateAction<DigitalProductChangeInterface>>;
  onToggleLectureEditor?: (lectureId?: number) => void;
};
export const CourseGateway = t0 => {
  const $ = _c(99);
  const {
    courseId,
    tempState,
    errors,
    setTempState,
    setTempProduct,
    onToggleLectureEditor
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [courseType, setCourseType] = useState(null);
  const {
    storeId
  } = useStoreQuery();
  const {
    data: store
  } = useStore(storeId);
  const {
    courseData
  } = useCourse(courseId);
  const {
    data: courseCurriculumData
  } = useCourseCurriculum(courseId);
  const {
    showCoursePreview
  } = useCoursePreview();
  const isLightCourse = courseData?.courseType === CourseEditorTypeEnum.LightCourse;
  const isAdvancedCourse = courseData?.courseType === CourseEditorTypeEnum.ClassicCourse;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setCourseType(null);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleBackToGateway = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = async () => {
      setCourseType(CourseTypeEnum.Light);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleLightCourseSelect = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setCourseType(CourseTypeEnum.Advanced);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleAdvancedCourseSelect = t3;
  let t4;
  if ($[3] !== setTempProduct || $[4] !== setTempState) {
    t4 = courseId_0 => {
      setTempState(prev => ({
        ...prev,
        courseId: courseId_0
      }));
      setTempProduct(prev_0 => ({
        ...prev_0,
        resources: [{
          course: courseId_0,
          enrollmentAccessType: AccessTypeEnum.fullAccess,
          modules: [],
          type: DigitalResourcesTypeEnum.membership_course
        }]
      }));
    };
    $[3] = setTempProduct;
    $[4] = setTempState;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleCourseChange = t4;
  let t5;
  if ($[6] !== courseCurriculumData || $[7] !== courseData || $[8] !== onToggleLectureEditor || $[9] !== showCoursePreview) {
    t5 = lectureId => {
      if (!lectureId) {
        showCoursePreview(courseData, courseCurriculumData);
      }
      onToggleLectureEditor?.(lectureId);
    };
    $[6] = courseCurriculumData;
    $[7] = courseData;
    $[8] = onToggleLectureEditor;
    $[9] = showCoursePreview;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleToggleLectureEditor = t5;
  let t6;
  let t7;
  if ($[11] !== courseCurriculumData || $[12] !== courseData || $[13] !== showCoursePreview) {
    t6 = () => {
      showCoursePreview(courseData, courseCurriculumData);
    };
    t7 = [courseData, courseCurriculumData, showCoursePreview];
    $[11] = courseCurriculumData;
    $[12] = courseData;
    $[13] = showCoursePreview;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  useEffect(t6, t7);
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="[&>svg>path]:fill-text-tertiary group-hover:[&>svg>path]:fill-text-primary [&>svg>path]:main-transition-colors rotate-180"><ArrowRightIcon /></div>;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("dashboard.store.course_type_selection");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <button onClick={handleBackToGateway} className="hover:text-text-primary main-transition-colors group flex items-center gap-2 text-lg font-medium">{t8}{t9}</button>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const backButton = t10;
  if (!courseType) {
    const t11 = isLightCourse && "border-brand-primary border";
    let t12;
    if ($[21] !== t11) {
      t12 = twMerge("relative w-full md:w-[446px] p-4 md:p-5 pb-8 md:pb-10 flex flex-col items-start gap-4 border rounded-lg border-text-tertiary/50 hover:border-brand-primary hover:border cursor-pointer main-transition-colors", t11);
      $[21] = t11;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    let t13;
    if ($[23] !== t) {
      t13 = t("dashboard.light_course.recommended");
      $[23] = t;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    let t14;
    if ($[25] !== t13) {
      t14 = <span className="bg-brand-primary/20 text-text-primary absolute right-4 top-4 rounded-3xl px-2 py-1 text-xs font-semibold md:right-5 md:top-5 md:px-3 md:py-1 md:text-sm">{t13}</span>;
      $[25] = t13;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    const t15 = isLightCourse && "fill-brand-primary [&>path]:fill-brand-primary";
    let t16;
    if ($[27] !== t15) {
      t16 = twMerge("[&>svg>path]:main-transition-colors", t15);
      $[27] = t15;
      $[28] = t16;
    } else {
      t16 = $[28];
    }
    let t17;
    if ($[29] !== t16) {
      t17 = <HatWithPlus className={t16} />;
      $[29] = t16;
      $[30] = t17;
    } else {
      t17 = $[30];
    }
    let t18;
    if ($[31] !== t) {
      t18 = t("dashboard.light_course.title");
      $[31] = t;
      $[32] = t18;
    } else {
      t18 = $[32];
    }
    let t19;
    if ($[33] !== t18) {
      t19 = <div className="text-text-primary text-lg font-extrabold">{t18}</div>;
      $[33] = t18;
      $[34] = t19;
    } else {
      t19 = $[34];
    }
    let t20;
    if ($[35] !== t) {
      t20 = t("dashboard.light_course.description");
      $[35] = t;
      $[36] = t20;
    } else {
      t20 = $[36];
    }
    let t21;
    if ($[37] !== t20) {
      t21 = <p className="text-sm font-normal">{t20}</p>;
      $[37] = t20;
      $[38] = t21;
    } else {
      t21 = $[38];
    }
    let t22;
    if ($[39] !== courseData || $[40] !== isLightCourse || $[41] !== t) {
      t22 = isLightCourse && <div className="text-text-primary mt-auto text-base font-bold"><span className="mr-1">{t("dashboard.store.selected_course")}:</span><span>{courseData.name}</span></div>;
      $[39] = courseData;
      $[40] = isLightCourse;
      $[41] = t;
      $[42] = t22;
    } else {
      t22 = $[42];
    }
    let t23;
    if ($[43] !== t12 || $[44] !== t14 || $[45] !== t17 || $[46] !== t19 || $[47] !== t21 || $[48] !== t22) {
      t23 = <div className={t12} onClick={handleLightCourseSelect}>{t14}{t17}{t19}{t21}{t22}</div>;
      $[43] = t12;
      $[44] = t14;
      $[45] = t17;
      $[46] = t19;
      $[47] = t21;
      $[48] = t22;
      $[49] = t23;
    } else {
      t23 = $[49];
    }
    const t24 = isAdvancedCourse && "border-brand-primary border";
    let t25;
    if ($[50] !== t24) {
      t25 = twMerge("relative w-full md:w-[446px] p-4 md:p-5 pb-8 md:pb-10 flex flex-col items-start gap-4 border rounded-lg border-text-tertiary/50 hover:border-brand-primary hover:border cursor-pointer main-transition-colors", t24);
      $[50] = t24;
      $[51] = t25;
    } else {
      t25 = $[51];
    }
    const t26 = isAdvancedCourse && "fill-brand-primary [&>path]:fill-brand-primary";
    let t27;
    if ($[52] !== t26) {
      t27 = twMerge("[&>svg>path]:main-transition-colors", t26);
      $[52] = t26;
      $[53] = t27;
    } else {
      t27 = $[53];
    }
    let t28;
    if ($[54] !== t27) {
      t28 = <HatWithCheck className={t27} />;
      $[54] = t27;
      $[55] = t28;
    } else {
      t28 = $[55];
    }
    let t29;
    if ($[56] !== t) {
      t29 = t("dashboard.store.advanced_course.title");
      $[56] = t;
      $[57] = t29;
    } else {
      t29 = $[57];
    }
    let t30;
    if ($[58] !== t29) {
      t30 = <div className="text-text-primary text-lg font-extrabold">{t29}</div>;
      $[58] = t29;
      $[59] = t30;
    } else {
      t30 = $[59];
    }
    let t31;
    if ($[60] !== t) {
      t31 = t("dashboard.store.advanced_course.description");
      $[60] = t;
      $[61] = t31;
    } else {
      t31 = $[61];
    }
    let t32;
    if ($[62] !== t31) {
      t32 = <p className="text-sm font-normal">{t31}</p>;
      $[62] = t31;
      $[63] = t32;
    } else {
      t32 = $[63];
    }
    let t33;
    if ($[64] !== courseData || $[65] !== isAdvancedCourse || $[66] !== t) {
      t33 = isAdvancedCourse && <div className="text-text-primary mt-auto text-base font-bold"><span className="mr-1">{t("dashboard.store.selected_course")}:</span><span>{courseData.name}</span></div>;
      $[64] = courseData;
      $[65] = isAdvancedCourse;
      $[66] = t;
      $[67] = t33;
    } else {
      t33 = $[67];
    }
    let t34;
    if ($[68] !== t25 || $[69] !== t28 || $[70] !== t30 || $[71] !== t32 || $[72] !== t33) {
      t34 = <div className={t25} onClick={handleAdvancedCourseSelect}>{t28}{t30}{t32}{t33}</div>;
      $[68] = t25;
      $[69] = t28;
      $[70] = t30;
      $[71] = t32;
      $[72] = t33;
      $[73] = t34;
    } else {
      t34 = $[73];
    }
    let t35;
    if ($[74] !== t23 || $[75] !== t34) {
      t35 = <div className="flex flex-col items-stretch gap-4 md:flex-row xl:gap-8">{t23}{t34}</div>;
      $[74] = t23;
      $[75] = t34;
      $[76] = t35;
    } else {
      t35 = $[76];
    }
    let t36;
    if ($[77] !== errors.courseId || $[78] !== t) {
      t36 = errors.courseId && t("dashboard.store.item.e_course.select_course.course_is_not_selected_error");
      $[77] = errors.courseId;
      $[78] = t;
      $[79] = t36;
    } else {
      t36 = $[79];
    }
    let t37;
    if ($[80] !== t36) {
      t37 = <FieldErrorAndDescription error={t36} />;
      $[80] = t36;
      $[81] = t37;
    } else {
      t37 = $[81];
    }
    let t38;
    if ($[82] !== t35 || $[83] !== t37) {
      t38 = <div className="flex flex-col gap-5">{t35}{t37}</div>;
      $[82] = t35;
      $[83] = t37;
      $[84] = t38;
    } else {
      t38 = $[84];
    }
    return t38;
  }
  if (courseType === CourseTypeEnum.Light) {
    const t11 = store?.domainId;
    const t12 = tempState.courseId ?? undefined;
    let t13;
    if ($[85] !== backButton || $[86] !== errors.courseId || $[87] !== handleCourseChange || $[88] !== handleToggleLectureEditor || $[89] !== t11 || $[90] !== t12) {
      t13 = <LightCourseEditor domainId={t11} courseId={t12} courseSelectorError={errors.courseId} backButton={backButton} onChangeCourse={handleCourseChange} onToggleLectureEditor={handleToggleLectureEditor} />;
      $[85] = backButton;
      $[86] = errors.courseId;
      $[87] = handleCourseChange;
      $[88] = handleToggleLectureEditor;
      $[89] = t11;
      $[90] = t12;
      $[91] = t13;
    } else {
      t13 = $[91];
    }
    return t13;
  }
  if (courseType === CourseTypeEnum.Advanced) {
    const t11 = tempState.courseId ?? undefined;
    let t12;
    if ($[92] !== errors.courseId || $[93] !== handleCourseChange || $[94] !== t11) {
      t12 = <ClassicCourse courseId={t11} courseSelectorError={errors.courseId} onChangeCourse={handleCourseChange} />;
      $[92] = errors.courseId;
      $[93] = handleCourseChange;
      $[94] = t11;
      $[95] = t12;
    } else {
      t12 = $[95];
    }
    let t13;
    if ($[96] !== backButton || $[97] !== t12) {
      t13 = <div className="flex flex-col gap-5">{backButton}{t12}</div>;
      $[96] = backButton;
      $[97] = t12;
      $[98] = t13;
    } else {
      t13 = $[98];
    }
    return t13;
  }
  return null;
};